import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTranslation } from 'react-i18next';

interface ErrorScreenProps {
	onPrevious: () => void;
}

const ErrorScreen: React.FC<ErrorScreenProps> = ({ onPrevious }) => {
	const { t } = useTranslation();

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				height: '100%',
				width: '100%',
				backgroundColor: 'background.default',
				p: 4,
				gap: 4
			}}
		>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					flex: 1
				}}
			>
				<ErrorOutlineIcon
					sx={{
						fontSize: 180,
						color: 'grey.300'
					}}
				/>
			</Box>

			<Box
				sx={{
					flex: 2,
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'flex-start',
					p: 3
				}}
			>
				<Typography variant="h4" sx={{ mb: 2, fontWeight: 500 }}>
					{t('error_page:error_screen_title')}
				</Typography>
				<Typography variant="body1" sx={{ mb: 1 }}>
					{t('error_page:error_screen_description')}
				</Typography>
				<Typography variant="body1" sx={{ mb: 3 }}>
					{t('error_page:error_screen_description_2')}
				</Typography>
				<Button variant="contained" onClick={onPrevious} startIcon={<ArrowBackIcon />}>
					{t('error_page:back_to_previous_page')}
				</Button>
			</Box>
		</Box>
	);
};

export { ErrorScreen };
